import { ComponentProps, useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import Headline from 'modules/nps/components/Headline'
import { useNpsVisibilityAllProducts } from 'modules/nps/hooks/useNpsVisibility'

const GeneralNpsPage = () => {
  const [selectedProduct, setSelectedProduct] = useState('')
  const { navigation } = useNavigation()
  const productsVisibility = useNpsVisibilityAllProducts()
  const options: ComponentProps<typeof SelectField>['options'] = Object.entries(
    productsVisibility.filter((e) => e.shouldShow)
  ).map(([_, { productName, productId }]) => {
    return { label: productName, value: productId }
  })

  useEffect(() => {
    track(trackingEvents.nps.visitsNpsPage)
  }, [])

  return (
    <Box
      maxWidth="s600"
      alignItems="center"
      justifyContent="center"
      style={{ height: '60vh' }}
      textAlign="center"
      gap="s32"
    >
      <Headline
        text={i18n.t('nps.survey_page.selector.headline', {
          productName: i18n.t('common.company_name'),
        })}
        icon="comment"
      />
      <Box flexDirection="row" gap="s16" alignItems="center" justifyContent="center" width="full">
        <SelectField
          onChange={(product) => {
            setSelectedProduct(product)
          }}
          options={options}
          value={selectedProduct}
          none={i18n.t('nps.survey_page.selector.selector_placeholder')}
        />
        <Button.Router
          disabled={!selectedProduct}
          to={navigation.nps.item.fullPath({ id: selectedProduct })}
        >
          {i18n.t('nps.survey_page.selector.button')}
        </Button.Router>
      </Box>
    </Box>
  )
}

export default GeneralNpsPage
